import Helpers from "@/helpers/Helpers";

export default [
  //   SITES
  {
    path: "clients/:clientId/:contentType(sites)/:siteId/edit",
    name: "SiteEdit",
    component: Helpers.lazyLoad("SiteAddEditView", "views/content/sites"),
    meta: { requiresAuth: true }
  },
  {
    path: "clients/:clientId/:contentType(sites)/:siteId(add)",
    name: "SiteAdd",
    components: { default: Helpers.lazyLoad("SiteAddEditView", "views/content/sites") },
    meta: { requiresAuth: true }
  }
];
